module.exports = __webpack_public_path__ + "static/media/image.c48ff6b9.png";